import { Media } from '@pixacare/domain';
import { uuidv4 } from '@shared/utils/utils';
import { ArucoPicture } from '../models/aruco-picture';
import { ArucoSticker } from '../models/aruco-sticker';

export const toArucoPicture = (input: Media | File, sticker?: ArucoSticker): ArucoPicture => {
  if (input instanceof File) {
    return {
      id: uuidv4(),
      source: URL.createObjectURL(input),
      filename: '',
      originalFilename: input.name,
      arucoDetected: sticker?.hasMarkers,
      arucoSurface: sticker?.surface,
      isSelected: false,
      isFile: true,
    };
  } else {
    return {
      id: uuidv4(),
      source: input.uri,
      filename: input.filename,
      originalFilename: input.originalFilename,
      arucoDetected: sticker?.hasMarkers,
      arucoSurface: sticker?.surface,
      isSelected: false,
      isFile: false,
    };
  }
};
